import { KycIntegrationMethodStatus } from '@nemuru-eng/js-api-client';

import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { CompletedKyc } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/CompleteKYC/CompletedKyc';
import { KYCActionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/CompleteKYC/KYCActionWrapper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { StyledAccordion } from '@/components/shared/components/StyledAccordion';
import { Text } from '@/components/shared/components/Text';

export const NextActionCompleteKYC = ({
  paymentMethodDetailEntity,
}: {
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}) => {
  const { kycIntegrationMethods } = paymentMethodDetailEntity;

  if (!kycIntegrationMethods?.length) {
    return null;
  }

  const notCompletedKycIntegrationMethods = kycIntegrationMethods.filter(
    (kyc) => kyc.status !== KycIntegrationMethodStatus.COMPLETED && kyc.status !== KycIntegrationMethodStatus.ACCEPTED,
  );
  const completedKycIntegrationMethods = kycIntegrationMethods.filter(
    (kyc) => kyc.status === KycIntegrationMethodStatus.COMPLETED || kyc.status === KycIntegrationMethodStatus.ACCEPTED,
  );

  return (
    <FlexColumn gridGap={16} width="100%">
      {notCompletedKycIntegrationMethods.map((kycIntegrationMethod, i) => {
        return (
          <KYCActionWrapper
            paymentMethodDetailEntity={paymentMethodDetailEntity}
            kycIntegrationMethod={kycIntegrationMethod}
            key={i}
          />
        );
      })}
      <StyledAccordion.Accordion style={{ width: '100%' }}>
        <StyledAccordion.AccordionSummary
          style={{ marginTop: '0', display: 'flex', alignItems: 'center', height: '24px' }}
          expandIcon={
            <Font variant="caption" color="textSecondary" style={{ display: 'flex' }}>
              <Icon>expand_more</Icon>
            </Font>
          }
        >
          <FlexRow justifyContent={'flex-end'} width={'100%'}>
            <Font variant="body2" color="textPrimary" align="right">
              <Text tId={'KYC_COMPLETED_VERIFICATION_TEXT_SECTION'} /> ({completedKycIntegrationMethods.length})
            </Font>
          </FlexRow>
        </StyledAccordion.AccordionSummary>
        <StyledAccordion.AccordionDetails>
          <FlexColumn width="100%" paddingX={'8px'}>
            {completedKycIntegrationMethods.map((kycIntegrationMethod, i) => (
              <CompletedKyc key={i} kycIntegrationMethod={kycIntegrationMethod} />
            ))}
          </FlexColumn>
        </StyledAccordion.AccordionDetails>
      </StyledAccordion.Accordion>
    </FlexColumn>
  );
};
